import React, { useCallback } from 'react';
import { Table } from '@devexpress/dx-react-grid-material-ui';
import { push } from 'connected-react-router';
import { useDispatch } from "react-redux";



const ClientPatientTableRow = (props) => {
	const id = props.row.patient_id,
		  dispatch = useDispatch();

	const handleNavigate = useCallback(() => {
		dispatch(push(`/patients/view/${id}`));
	}, [ dispatch, id ]);


	return (
		<Table.Row
			{...props}
			style={{
				cursor: 'pointer',
			}}
			onClick={handleNavigate}
		/>
	);
};


export default ClientPatientTableRow;